
import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export type Profile = {
  id: string;
  email: string;
  full_name: string | null;
  phone: string | null;
  country: string | null;
  city: string | null;
  role: 'devotee' | 'admin';
  created_at: string;
  updated_at: string;
};

export type RitualBooking = {
  id: string;
  user_id: string | null;
  booking_number: string;
  devotee_names: string;
  email: string;
  phone: string | null;
  gotra: string | null;
  ritual_type: string;
  ritual_mode: string;
  preferred_date: string;
  country: string;
  timezone: string;
  purpose: string | null;
  status: 'pending' | 'confirmed' | 'in_progress' | 'completed' | 'cancelled';
  payment_status: 'pending' | 'paid' | 'refunded';
  amount: number | null;
  priest_name: string | null;
  temple_location: string | null;
  notes: string | null;
  created_at: string;
  updated_at: string;
};

export function generateBookingNumber(): string {
  try {
    const prefix = 'SO';
    const timestamp = Date.now().toString(36).toUpperCase();
    const random = Math.random().toString(36).substring(2, 6).toUpperCase();
    return `${prefix}-${timestamp}-${random}`;
  } catch (error) {
    console.error('Failed to generate booking number:', error);
    // Fallback to a simple timestamp‑based number
    return `SO-${Date.now()}`;
  }
}
